module.exports = __webpack_public_path__ + "img/Customer.io.72d06bf9.svg";